import { User } from '@turizi/shared';
import { MoneyTransaction } from './money-models';

export interface Subscription {
    id: number;
    tenant_id: number;
    name: string;
    cycle: string; // 'monthly', 'yearly', 'weekly', 'custom'
    price: number;
    currency: string;
    description: string | null;
    business_id: number | null;
    due_day: number | null;
    status: string;
    auto_payment?: boolean;
    can_delete?: boolean;
    can_edit?: boolean;
    created_by: User;
    updated_by: User | null;
    created_at: string;
    updated_at: string;

    // relationships
    payments?: MoneyTransaction[];
}

export const EMPTY_SUBSCRIPTION: Subscription = {
    id: null,
    tenant_id: null,
    name: '',
    cycle: 'monthly',
    price: 0,
    currency: 'ARS',
    description: '',
    business_id: null,
    due_day: 1,
    status: 'active',
    auto_payment: false,
    can_delete: true,
    can_edit: true,
    created_by: {} as User,
    updated_by: null,
    created_at: '',
    updated_at: ''
}
